import { MaskitoOptions } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

export const zeroToEighteenMask: MaskitoOptions = {
  mask: [/[0-1]?/, /\d/], // Allow 1 or 2 digits
  preprocessors: [
    ({ elementState, data }, actionType) => {
      const { value, selection } = elementState;
      // Remove non-digit characters
      const newValue = value.replace(/\D/g, '');

      // Ensure the number is between 0 and 18
      const number = parseInt(newValue, 10);
      if (isNaN(number) || number < 0 || number > 18) {
        return {
          elementState: {
            selection,
            value: ''
          },
          data
        }; // Reset the value if invalid
      }

      return {
        elementState: {
          selection,
          value: newValue,
        },
        data
      };
    },
  ],
};

export const poundsMask = maskitoNumberOptionsGenerator({
  precision: 0,
  thousandSeparator: ',' // Optional: formats thousands for easier readability
});

export function ukPhoneMask(rawValue: string): (string | RegExp)[] {
  // Remove all non-digit characters.
  const digits = rawValue.replace(/\D/g, '');

  // Ensure the number starts with "0".
  // If it doesn't, prepend "0" to the digits.
  const formatted = digits.startsWith('0') ? digits : '0' + digits;

  // Determine the desired mask length:
  // If less than 10 digits, force a 10-digit mask;
  // If more, allow up to 12 digits.
  const desiredLength = formatted.length < 10 ? 10 : Math.min(formatted.length, 12);

  // Build the mask array:
  // The first character is fixed as "0", then desiredLength-1 digit placeholders.
  const mask: (string | RegExp)[] = ['0'];
  for (let i = 1; i < desiredLength; i++) {
    mask.push(/\d/);
  }
  return mask;
}

export const ukMask: MaskitoOptions = {
  // This mask allows one alphabetical character (intended as the first letter)
  // followed by up to 50 lowercase letters (optional)
  mask: /^\d+$/,
  preprocessors: [
    ({ elementState, data }, actionType) => {
      let { value, selection } = elementState;

      if (value.length) {
        value = value.replace(/\D/g, '');
        value = value.replace(/^(044|44|00)/, '0');
        if (!value.startsWith('0'))
          value = '0' + value;
        if (value.length > 12)
          value = value.substring(0, 12);
      }

      return {
        elementState: {
          selection,
          value
        },
        data,
      };
    },
  ]
}

// masks.ts

export const titleCaseMask: MaskitoOptions = {
  // This mask allows one alphabetical character (intended as the first letter)
  // followed by up to 50 lowercase letters (optional)
  mask: /^\D+$/,
  preprocessors: [
    ({ elementState, data }, actionType) => {
      const { value, selection } = elementState;

      const newValue = value.replace(/\b(\w)/g, (_, firstLetter) => firstLetter.toUpperCase());

      return {
        elementState: {
          selection,
          value: newValue,
        },
        data,
      };
    },
  ]
};


export const masks: { [key: string]: MaskitoOptions } = {
  'pounds': poundsMask,
  'zeroToEighteen': zeroToEighteenMask,
  'name': titleCaseMask,
  'tel': ukMask,
  'any': { mask: /.*/ }
}
